'use client';

import { useEffect, useRef, useState } from 'react';
import Swiper from '../../components/Swiper';
import { twMerge } from 'tailwind-merge';
import { IPost } from './../../../models/ICategory';
import { SwiperProps } from 'swiper/react';
import Post from '../../components/Post';

interface Props {
  data: IPost[];
  setSelected: (idx: number) => void;
  selected?: number;
}

export default function HomepageSwiper({ setSelected, data, selected }: Props) {

  const swiperRef = useRef<any>();


  // const toggleAutoplay = (play: boolean) => {
  //   if (play) swiperRef.current.swiper.autoplay.start();
  //   else swiperRef.current.swiper.autoplay.stop();
  // }

  return (
    <Swiper
    itemsLength={data.length}
    selected={selected}
    setSelected={setSelected}
    id='home-banner'
    className='!h-[90px] tablet:[&>*]:!w-[328px] [&>*]:!h-[90px]'
    // wrapperClassName='h-[90px]'
      ref={swiperRef}
      swiperSlideProps={{
        className: 'pl-[24px] desktop:py-[0] tablet:first:pl-[24px] tablet:pl-[24px] h6',
      }}
      swiperProps={{


      }}
      slides={data.map((p, i) => <Post
      props={{
  onMouseEnter:() => {
    // toggleAutoplay(false);
          setSelected(i);
        },
        onMouseLeave: () => {
          //  toggleAutoplay(true);
        },
      }}
      
      {...p}
      key={p.uniqueCode}
            image={{src: p.imageUrls.url, alt: p.imageAlt || '', sizes: '100vw', className: 'rounded-tr-[12px] rounded-br-[12px]', priority: i <= 1, loading: i<= 1 ? 'eager' : 'lazy'}}
        hide={{category: true, publishedOn: true}}
        classNames={{
          wrapper: twMerge('flex-row bg-white group rounded-[12px] h-[90px] p-0'),
          image: 'w-[120px] h-full mb-0',
          contentContainer: 'px-[12px] justify-center py-[8px] group-hover:bg-gray-0 transition-all duration-300 rounded-tl-[12px] rounded-bl-[12px] w-full',
          title: 'text-[16px] leading-[24px] line-clamp-3 dark:text-black group-hover:text-black transition-all duration-300'
        }}
         />
      )}
    />
  )
}